import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const fileHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.file_html_label_media_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.file_html_ph_media_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
  '<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
    '<div class="dz-default dz-message">' +
      '<input type="file" class="d-none" name="uploaded-file-file" id="uploaded-file-file">' +
      '<i class="fas fa-file-download"></i>' +
    '</div>' +
  '</div>' +
  '<span class="text-small text-muted">' + lang.file_html_info_supported_media + '</span>' +
'</div>' +

// Adds html for delay system
delayHtml